module.exports = __webpack_public_path__ + "static/media/sh.5ab3ccf4.svg";